const SELECTORS = {
  active: "Faq--jsActive",
  tab: "Faq-tabBar",
  panels: "Faq-accordion",
  utils: {
    hidden: "u-hidden",
  },
};

class Faq {
  /**
   * @param {HTMLElement} faq
   */
  constructor(faq) {
    this.faq = faq;
    this._setBindings();
    this._queryElements();
    this._activateFaq();
    this._addMutationObserver();

    /**
     * This is necessary due to progressive enhancement. Without
     * js all panels are visible
     */
    this._updatePanels();
  }

  /**
   * Set context for callbacks
   */
  _setBindings() {
    this._handleMutation = this._handleMutation.bind(this);
  }

  /**
   * Get all necessary elements
   */
  _queryElements() {
    this.panels = this.faq.querySelectorAll(`.${SELECTORS.panels}`);
    this.tabBar = this.faq.querySelector(`.${SELECTORS.tab}`);
    this.tabs = [...this.panels].map((panel) =>
      this.tabBar.querySelector(`[aria-controls=${panel.id}]`)
    );
    this.current = this.tabBar.querySelector("[aria-selected=true]");
  }

  /**
   * Add class to enable progressive enhancements by js
   */
  _activateFaq() {
    this.faq.classList.add(SELECTORS.active);
  }

  /**
   * Observe aria-selected attribute on the tabBar
   */
  _addMutationObserver() {
    this.mutationObserver = new MutationObserver(this._handleMutation);
    this.mutationObserver.observe(this.tabBar, {
      attributeFilter: ["aria-selected"],
      subtree: true,
    });
  }

  /**
   * Handle aria-selected change in case its set to true
   *
   * @param {MutationRecord} records
   */
  _handleMutation(records) {
    records.forEach((record) => {
      if (record.target.getAttribute(record.attributeName) === "true") {
        this.current = record.target;
      }
    });
    this._updatePanels();
  }

  /**
   * Sync tabBar choice with panels
   */
  _updatePanels() {
    this.panels.forEach((panel) => {
      if (panel.id === this.current.getAttribute("aria-controls")) {
        Faq.openPanel(panel);
      } else {
        Faq.closePanel(panel);
      }
    });
  }

  /**
   * Open the panel by removing the is-closed class
   *
   * @param {HTMLElement} panel
   */
  static openPanel(panel) {
    panel.classList.remove(SELECTORS.utils.hidden);
  }

  /**
   * Close the panel by adding the is-closed class
   *
   * @param {HTMLElement} panel
   */
  static closePanel(panel) {
    panel.classList.add(SELECTORS.utils.hidden);
  }
}

export default Faq;
